<template>
  <div class="home" id="home1" v-if="siteDataReady">

    <!-- this is for rendering the fonts on start -->
    <div class="hiddenfonttext">{{localize(siteData.SECTIONS[0].desc)}}</div>

    <site-menu :isMenuOpen="isMenuOpen" @close-menu="isMenuOpen=false"></site-menu>
    <lang-menu :isMenuOpen="isLangOpen" @close-menu="isLangOpen=false"></lang-menu>

    <div :class="['topBar']">
      <img @click="navToStart" class="topLogo" src="/img/lance2.png" alt="" />      
      <!-- main menu opener -->
      <div class="menuOpen" @click="openMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <!-- lang menu opener -->
      <div class="menuLang" @click="toggleLangMenu" id="langtoggle1">
        {{getLangByRoute().toUpperCase()}}<i class="fal fa-chevron-down" ></i>
      </div>
    </div>    

    <div class="fixedHeroVideo">
        <home-hero></home-hero>
    </div>
    

    <main v-if="siteReady">
      <!--
      -->
      <section class="siteSection transparentSection">
        &nbsp; <!--empty transparent section for the video bg-->
      </section>
      <section class="siteSection heroText secBgGray1">
        <home-hero-text></home-hero-text>
      </section>
      <section class="siteSection secBgGray2">
        <home-benefits></home-benefits>
      </section>
      <section class="siteSection secBgWhite">
        <implant-range></implant-range>
      </section>
      <section class="siteSection secBgGray2">
        <tech-info></tech-info>
      </section>
      <section class="siteSection secBgWhite">
        <drilling-protocols></drilling-protocols>
      </section>
      <section class="siteSection">
        <coverscrews></coverscrews>
      </section>
      <section class="siteSection kit">
        <lance-kit></lance-kit>
      </section>
      <section class="siteSection secBgGray1">
        <insertion-options></insertion-options>
      </section>
      <section class="siteSection">
        <packaging></packaging>
      </section>
      <section class="siteSection secBgWhite">
        <prosthetic></prosthetic>
      </section>
      <section class="siteSection footer">
        <lance-footer></lance-footer>
      </section>
    </main>

      <!--
        
      Home view {{$route.params.lang}}
      Data: {{siteData}}
      -->
  </div>
</template>

<style>
    body::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    .hiddenfonttext
    {
      position: fixed;top:-100px;left:0px;font-size: 9px;
    }
    .topBar
    {
      position: fixed;
      z-index:100;
      top:0px;left:0px;
      width: 100vw;
      height: 70px;
      display: grid;
      align-items: center;     
      background-color:#1178be; 
    }
    .topBar .topLogo{
      width: 200px;height: auto;    
      padding-left: 30px;
    }
    .topBar .menuOpen
    {
        width:30px;height:24px;
        position: absolute;right: 40px; 
        opacity:0.7;cursor:pointer !important;    
    }
    .topBar .menuOpen span
    {
        width: 100%;height:2px;
        background-color: #fff;position: absolute;top:0px;cursor:pointer;
        pointer-events: none;
    }
    .topBar .menuOpen span:nth-child(1){top:0px;}
    .topBar .menuOpen span:nth-child(2){top:10px;}
    .topBar .menuOpen span:nth-child(3){top:20px;}

    .topBar .menuLang
    {
        width:60px;height:24px;
        position: absolute;
        right: 70px; 
        opacity:0.7;cursor:pointer !important;  
        color: #fff;  
        font-weight: bold;
    }
    .topBar .menuLang i
    {
      font-size: 12px;padding-left: 8px;opacity: 0.6;
    }

    .fixedHeroVideo
    {
      position: fixed;      
    }

    main {
      perspective: 2px;
      overflow-x: hidden;
      overflow-y: auto;  
    }

  .siteSection {
    transform-style: preserve-3d;
    position: relative;
    height: 100vh;width: 100%;
  }
  .siteSection.heroText{
    height: 50vh;
  }
  .siteSection.secBgWhite{
    background-color: #fff;
  }
  .siteSection.secBgGray1{
    background-color: #fcfcfc;    
  }
  .siteSection.secBgGray2{
    background-color: var(--graybg1);
  }

  .attachedLogo
  {
      position: absolute;
      top: 36px;
      left: 50px;
      width: 140px;height: 100%;      
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-position: 50px 37px;
      background-size:90px 47px;
      pointer-events: none;
  }
  .attachedLogo.black{
    background-image: url("/img/lance/lance_logo_black.png");
  }
  .attachedLogo.white{
    background-image: url("/img/lance/lance_logo_white.png");
  }

  .disabledSection
  {
    pointer-events: none !important;
  }

    .sectionTitle
    {
        font-size: 30px;
        font-weight: 200;
        letter-spacing: -1px;        
        text-align:center;        
        position:absolute;
        left: 0px;
        top:100px;width: 100%;        
    }  
    .sectionTitle.white
    {
      color: #fff !important;
    }
    .sectionTitle.black
    {
      color: #000 !important;
    }
    .sectionTitle.blue
    {
      color: var(--text-blue);
    }

    @media (max-width: 850px)
    {
      .topBar
      {
        width: 100vw;
        height: 80px;
        background-color: #1178be;
        opacity: 1;
      }
      .topBar .topLogo{
        width: 184px;
        height: auto;    
        padding-left: 20px;
      }
      .topBar .menuOpen
      {
        right: 25px; 
        top:30px;        
      }      
      .topBar .menuLang
      {
          position: absolute;right: 60px; 
          cursor:pointer !important;
          color: #fff;  
          font-weight: bold;
          height: auto;        
      }
      .siteSection
      {
        /* min-height: calc(100vh + 80px); */
        min-height: 60vh;
        position: static;
        height: auto;
        float: left;
      }
      .siteSection.heroText
      {
        height: auto;
        min-height: 30vh;
      }
      .siteSection.transparentSection
      {
        display: none;
      }

      .siteSection.footer
      {
        min-height: 400px !important;
        max-height: 100vh !important;
      }
      .siteSection.kit
      {
        min-height: 400px !important;
        max-height: 100vh !important;
      }

      .sectionTitle
      {
        font-size: 22px;
        position: static;
        text-align: center;
        padding-top: 100px;
      }        
      .fixedHeroVideo
      {
        position: initial;      
      }
      .siteSection.kit
      {
        min-height: 30vh;
        max-height: initial;
        height: auto;
      }
    }

    @media (max-width: 850px) and (orientation: portrait)
    {
      .siteSection.heroText{
        height: auto;
        min-height: initial;
      }

    }

</style>

<script>
  import LangMenu           from "@/views/com/langmenu.vue";
  import SiteMenu           from "@/views/com/menu.vue";
  import HomeHero           from "@/views/lance/LanceHero.vue";
  import HomeHeroText       from "@/views/lance/LanceHeroText.vue";
  import HomeBenefits       from "@/views/lance/LanceBenefits.vue";
  import ImplantRange       from "@/views/lance/LanceImplantRange.vue";
  import DrillingProtocols  from "@/views/lance/LanceDrillingProtocols.vue";
  import TechInfo           from "@/views/lance/LanceTechInfo.vue";
  import InsertionOptions   from "@/views/lance/LanceInsertionOptions.vue";
  import Packaging          from "@/views/lance/LancePackaging.vue";  
  import Coverscrews        from "@/views/lance/LanceCoverscrews.vue";  
  import Prosthetic         from "@/views/lance/LanceProsthetic.vue";  
  import LanceKit           from "@/views/lance/LanceKit.vue";  
  import LanceFooter        from "@/views/lance/LanceFooter.vue";    

  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        site_data:null,
        isMenuOpen:false,
        isLangOpen:false
      }
    },
    components:
    {
      LangMenu,
      SiteMenu,
      HomeHero,
      HomeHeroText,
      HomeBenefits,
      ImplantRange,
      DrillingProtocols,
      TechInfo,
      InsertionOptions,
      Packaging,
      Coverscrews,
      Prosthetic,
      LanceKit,
      LanceFooter,
      visibleSection:0
    }, 
    computed: {
    ...mapState(["siteData","siteDataReady","siteReady","siteVisibleSection"]),
  },
  mounted()
  {
    var vm=this;
    setTimeout(() => {
      vm.addDocumentEvents();
    }, 1000);
  },
  created: function () {      

      var vm = this;

      this.initScrollListener();
      this.loadData();      
      this.preloadFonts();
    },
  destroyed() {
      window.removeEventListener("scroll", this.scrollHandler);
  },

    methods: {
      ...mapActions(["xSetPlatform","loadSiteData","setSiteReady","setVisibleSection"]),
      addDocumentEvents()
      {
          //forct redirect to https
          if(window.location.protocol!= 'https:' && 
              window.location.hostname!='localhost'){
              window.location.protocol="https";
            }

          //check if user clicked out side of the languages menu or outside of the language top toggler
          var vm = this;
          var langtoggle1 = document.getElementById("langtoggle1");
          var langmenuObj = document.getElementById("langmenu1");          
          document.addEventListener('click', function(event) {
            const outsideClick = !langtoggle1.contains(event.target) && !langmenuObj.contains(event.target);
            if(outsideClick){
                vm.isLangOpen=false;//close langaue menu
            }
          });
      },
      preloadFonts()
      {
        var vm = this;
        if (document && document.fonts) {  
          //CSS Font Loading API
          //https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API
          
          const font1 = new FontFace("Inter", "url(https://fonts.googleapis.com/css?family=Inter:200,300,400,500&display=swap&subset=latin-ext)");
          document.fonts.add(font1);
          font1.load();
          document.fonts.ready.then(() => {            
            //alert("font loaded");
            //add hidden text
            setTimeout(() => {              
              vm.setSiteReady(true);
            }, 300);
          });
      } else {
          vm.setSiteReady(true);// Fallback if API does not exist 
      }
    },      
    navToStart()
    {
        document.getElementsByClassName("siteSection")[0].scrollIntoView({ 
          behavior: 'smooth' 
        });
    },
    initScrollListener() 
    {
      window.addEventListener("scroll", this.scrollHandler, false);      
    },    
    scrollHandler() {
      //this.pageScrollTop = document.documentElement.scrollTop;
      //this.revealElements();
      this.checkSectionsView();
    },
    checkSectionsView()
    {
      var vm=this;
      var reveals = document.querySelectorAll(".siteSection");
      for (var i = 0; i < reveals.length; i++) 
      {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 350;
        if (elementTop < windowHeight - elementVisible && elementTop>0) 
        {
          if(vm.visibleSection != i)
          {
            vm.visibleSection = i;
            vm.onSectionVisivle(i);
            //console.log("++ visibleSection="+vm.visibleSection);
          }
        }
      }
    },
    onSectionVisivle(domSectionIndex)
    {
        ///////////
        ///////////
        ///////////
        var vm=this;
        let sectionIndex = domSectionIndex;

        var sectionElement = document.querySelectorAll(".siteSection")[domSectionIndex];

        let sectionDataIndex = sectionIndex;
        if(sectionIndex>0){
          sectionDataIndex--;//!important because the dom 1st section is empty section
        }

        var secData =  this.siteData.SECTIONS[sectionDataIndex];

        var vid = document.getElementById("videoBgHero");

        //not sure if we will need this:
        this.setVisibleSection(sectionIndex);//change the store value

        if(domSectionIndex>2){          
          vid.pause();//pause video when hero is hidden
          //when scrolling to section 2 (ImplantRange) or futher, by defult select the 3.75 platform
          setTimeout(() => {
            vm.xSetPlatform(1);  
          }, 1800);
        }else{
          vid.play();//resume video when hero is visible
        }
        //check when kit section is revealed

        if(secData.section=='benefits')
        {
          //the scroller on benefits is hidden becuase it's stopping the site from scrolling the hero to the benefits
          //when revealing the 'benefits' section set timeout for 1 sec and show the benfits scroller
          //imgBnScroller1 add 'show' class after 1 sec
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("show");//(display block)           
          }, 1100);
          setTimeout(() => {
            var imgBnScroller1 = document.getElementById("bnScrollerWrapper");
            imgBnScroller1.classList.add("showOpaq"); //remove opacity            
          }, 1300);
        }
        
        if(secData.section == 'surgical_kit')
        {
          var kitVideo = document.getElementById("kitVideo");
          kitVideo.play();//start kit video 
        }

        this.revealSectionChildrenElements(sectionElement);
    },

    // REAVEL CHILD ELEMENTS 
    revealSectionChildrenElements(parentElement) 
    {
      var vm=this;
      parentElement.classList.add("active");

      var reveals = parentElement.querySelectorAll(".reveal");
      for (var i = 0; i < reveals.length; i++){
          if(reveals[i].classList.contains("active")==false)
          {
            vm.onRevealingSection(reveals[i].id);
            reveals[i].classList.add("active");
          }
      }
    },
    onRevealingSection(sectionID)
    {
      if(sectionID=='hpSpeakers' || 
          sectionID=='hpProgram'){
        //Add delay to enable this section
        //this is to avoid mouse colloision on circles animations
        setTimeout(() => {
          let sectionElement = document.getElementById(sectionID);
          sectionElement.classList.remove("disabledSection");
        }, 1500);
      }
    },      
      toggleLangMenu()
      {
        if(this.isLangOpen){
          this.isLangOpen = false;//close it
        }else{
          this.isLangOpen = true;//open lang
          this.isMenuOpen=false;//close main menu
        }
      },
      openMenu()
      {
        this.isMenuOpen=true;
        this.isLangOpen=false;
      },
      getLangByRoute()
      {
        let lc = this.$route.params.lang;
        if(lc == undefined){lc="en";}
        return lc;
      },
      loadData: function () 
      {
        let lc = this.getLangByRoute();                
        this.loadSiteData(lc);
      }
    },
    watch: 
    { 
     '$route.params.lang': {        
        handler: function(lang) {          
          this.loadData();
        },
        deep: true,immediate: false
      }
    }   
  }
</script>
